import SealOneIllustration from "../../assets/builder/seal/SealOneIllustration";
import SealThreeIllustration from "../../assets/builder/seal/SealThreeIllustration";
import SealTwoIllustration from "../../assets/builder/seal/SealTwoIllustration";
import { CheckoutComponentSealAttibutesType } from "../../types/builder";
import CheckoutComponentAlignmentContainer from "./CheckoutComponentAlignmentContainer";

const Seal = {
  one: SealOneIllustration,
  two: SealTwoIllustration,
  three: SealThreeIllustration,
};

const CheckoutComponentSeal: React.FC<CheckoutComponentSealAttibutesType> = ({
  ...attributes
}) => {
  const SealComponent = Seal[attributes.type] || null;
  return (
    <CheckoutComponentAlignmentContainer alignment={attributes.alignment}>
      <div
        style={{
          width: `${attributes.width}px`,
        }}
        className="flex flex-col items-center"
      >
        {SealComponent && <SealComponent {...attributes} />}
      </div>
    </CheckoutComponentAlignmentContainer>
  );
};

export default CheckoutComponentSeal;
